import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Select from 'flarum/common/components/Select';
import Stream from 'flarum/utils/Stream';

import InfoReportSuccessModal from "./InfoReportSuccessModal";

export default class ItemQueryModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    this.loading = false;
    this.infoBaseData = this.attrs.infoBaseData;
    this.itemID = this.infoBaseData.id();
    this.itemSN = this.infoBaseData.sn();
    this.itemReportType = Stream("0");
  }

  className() {
    return 'Modal--small';
  }

  title() {
    return app.translator.trans('ziven-u2di.forum.title-report');
  }

  content() {
    return [
      <div className="Modal-body" style="padding-top: 0px;text-align:center">
        <div style="padding-bottom: 10px;">
          {app.translator.trans("ziven-u2di.forum.item-sn")}: {this.itemSN}
        </div>
        <div className="u2diItemReportContainier">
          <Select className="u2diDataSelectList" value={this.itemReportType()}
            disabled={this.loading}
            options={{
              "0":app.translator.trans("ziven-u2di.forum.list-item-report-0"),
              "1":app.translator.trans("ziven-u2di.forum.list-item-report-1"),
              "2":app.translator.trans("ziven-u2di.forum.list-item-report-2"),
            }}
            onchange={(e) => { 
              this.itemReportType(e); 
            }}
          />
        </div>
        <div style="text-align: center;padding-top: 20px;">
          {Button.component({
              style:"min-width:66px;",
              disabled: this.loading || this.itemReportType()==0,
              type: 'submit',
              className: 'Button Button--primary',
              onclick: (e) => {
                this.submitData(e);
              }
            },
            app.translator.trans('ziven-u2di.lib.submit')
          )}
          &nbsp;
          {Button.component({
              style:"min-width:66px;",
              className: 'Button U2DiButton--gray',
              disabled: this.loading,
              onclick: () => {
                this.hide();
              }
            },
            app.translator.trans('ziven-u2di.lib.cancel')
          )}
        </div>
      </div>,
    ];
  }

  submitData(e) {
    e.preventDefault();
    this.loading = true;
    
    const submitData = {
      itemID: this.itemID,
      itemReportType: this.itemReportType()
    };

    $(".Modal-close").hide();

    app.store
      .createRecord("u2diInfoReports")
      .save(submitData)
      .then((result) => {
          app.modal.show(InfoReportSuccessModal);
        }
      )
      .catch((e) => {
        this.loading = false;
      });

  }
}